import script from "./RequestUpdateModalForBarcode.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForBarcode.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForBarcode.vue?vue&type=style&index=0&id=a853569e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a853569e"]])

export default __exports__